import { render, staticRenderFns } from "./ServiceCategoriesView.vue?vue&type=template&id=696469ce"
import script from "./ServiceCategoriesView.vue?vue&type=script&lang=js"
export * from "./ServiceCategoriesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports